import React from "react";
import { Switch, Route, Redirect } from "react-router";

import TipoCadastro from "./screens/tipoCadastro";
import DadosIniciaisPF from "./screens/dadosIniciaisPF";
import DadosIniciaisPJ from "./screens/dadosIniciaisPJ";
import Endereco from "./screens/endereco";
import DadosComplementares from "./screens/dadosComplementares";
import MaisDetalhes from "./screens/maisDetalhes";
import DeclaracaoEspecifica from "./screens/declaracaoEspecifica";
import Resumo from "./screens/resumo";
import DocumentosAnexos from "./screens/documentosAnexos";
import Conclusao from "./screens/conclusao";
import Contrato from "./screens/contrato";
import ConfirmacaoEmail from "./screens/confirmacaoEmail";
import ConfirmacaoEmailAlteracao from "./screens/confirmacaoEmailAlteracao";
import DadosBancarios from "./screens/dadosBancarios";
import Formulario from "./screens/kyc/formulario";
import InicioFormulario from "./screens/kyc";
import FormularioSucesso from "./screens/kyc/sucesso";
import UploadDocumentos from "./screens/uploadDocumentos";
import Cotacao from "./screens/cotacao";
import RenovacaoDocumentos from "./screens/renovacaoDocumentos";

class Routes extends React.Component {
  render() {
    return (
      <Switch>
        <Route
          path="/"
          exact={true}
          component={() => <Redirect to="/vamosComecar" />}
        />
        <Route path="/vamosComecar" component={TipoCadastro} />
        <Route path="/dadosIniciaisPF" component={DadosIniciaisPF} />
        <Route path="/dadosIniciaisPJ" component={DadosIniciaisPJ} />
        <Route path="/endereco" component={Endereco} />
        <Route path="/dadosComplementares" component={DadosComplementares} />
        <Route path="/maisDetalhes" component={MaisDetalhes} />
        <Route
          path="/declaracoesEspecificas"
          component={DeclaracaoEspecifica}
        />
        <Route path="/documentosAnexos" component={DocumentosAnexos} />
        <Route path="/resumo" component={Resumo} />
        <Route path="/conclusao" component={Conclusao} />
        <Route path="/contrato" component={Contrato} />
        <Route path="/confirmacaoEmail/:id" component={ConfirmacaoEmail} />
        <Route path="/confirmacaoEmailAlteracao/:id" component={ConfirmacaoEmailAlteracao} />
        <Route path="/dadosBancarios" component={DadosBancarios} />
        <Route path="/kyc/formulario/:id" component={Formulario} />
        <Route path="/kyc/sucesso" component={FormularioSucesso} />
        <Route path="/kyc/:id" component={InicioFormulario} />
        <Route path="/uploadDocumentos/:id" component={UploadDocumentos} />
        <Route path="/cotacao" component={Cotacao} />
        <Route path="/renovacaoDocumentos/:id" component={RenovacaoDocumentos} />
      </Switch>
    );
  }
}

export default Routes;
